<template>
  <iMenu
    ref="menu"
    :active-name="$route.name"
    :open-names="openNames"
    :class="{ 'collapsed-menu': collapsed }"
    theme="dark"
    width="auto"
    @on-select="onSelect"
  >
    <SideBarItem
      v-for="item in menuList"
      :key="item.name"
      :item="item"
      :collapsed="collapsed" />
  </iMenu>
</template>

<script>
import Vue from 'vue';
import { flattenDeep } from 'lodash';

import SideBarItem from './components/SideBarItem.vue';

export default {
  components: { SideBarItem },
  props: {
    collapsed: { type: Boolean, default: false },
  },
  data() {
    return {
      menuList: [
        {
          name: 'admin',
          icon: 'settings',
          title: 'layouts.main.menu.admin',
          children: [
            { name: 'admin-users', title: 'layouts.main.menu.admin_users', route: true },
            { name: 'site-users', title: 'layouts.main.menu.users', route: true },
          ],
        },
        {
          name: 'formaat',
          icon: 'pricetag',
          title: 'layouts.main.menu.formaat',
          children: [
            { name: 'formaat-clients', title: 'layouts.main.menu.clients', route: true },
          ],
        },
      ],
    };
  },
  computed: {
    openNames() {
      Vue.nextTick(() => { this.$refs.menu.updateOpened(); });
      if (this.collapsed) return [];
      const route = this.$route.name;
      const checkOpen = (i) => {
        if (i.children) return i.children.some(checkOpen);
        return i.name === route;
      };

      const item = this.menuList.find(checkOpen);
      if (item) return [item.name];
      return [];
    },
    menuListFlatten() {
      function flatten(item) {
        if (item.children) return item.children.map(flatten);
        return [item];
      }
      return flattenDeep(this.menuList.map(flatten));
    },
  },
  methods: {
    onSelect(name) {
      const item = this.menuListFlatten.find(i => i.name === name);
      if (item && item.route) {
        this.$router.push({ name: item.name });
      }
    },
  },
};
</script>

<style scoped>

</style>
